import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {OrganizationService} from "../_service/organization.service";
import {isNullOrUndefined, isUndefined} from "util";
import {AliasGuard} from "./alias.guard";

@Injectable()
export class AliasWithoutStorageGuard extends AliasGuard implements CanActivate {
  public extracted(isAliasExist, alias, result: boolean) {
    console.warn("In check alias in AliasGuard result: ", isAliasExist);
    if (isAliasExist.isExist) {
      return true;
    } else {
      this.router.navigate(["error"]);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/tmpName/alias-without-storage.guard.ts